export default __webpack_public_path__ + "static/reviews-ed7e4c44648bd3f6c03f7c6949c70c85.jpg";